import {
  Container,
  FormControl,
  FormControlLabel,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { Stack } from "@mui/system";
import queryString from "query-string";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { init, save } from "../../redux/actions/webEvaluation2";
import Header from "../common/Header";

export default function WebEvaluation2() {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const grade = useSelector((state) => state.webEvaluation2.grade);
  const gradeRange = useSelector((state) => state.webEvaluation2.gradeRange);
  const classNumber = useSelector((state) => state.webEvaluation2.classNumber);
  const number = useSelector((state) => state.webEvaluation2.number);
  const name = useSelector((state) => state.webEvaluation2.name);
  const title = useSelector((state) => state.webEvaluation2.title);
  const item = useSelector((state) => state.webEvaluation2.item);

  // Mapping of grade labels to stickerIds
  const gradeMapping = [
    { value: 6, label: "E", stickerId: "06" },
    { value: 5, label: "D", stickerId: "05" },
    { value: 4, label: "C", stickerId: "04" },
    { value: 3, label: "B", stickerId: "03" },
    { value: 2, label: "A", stickerId: "02" },
    { value: 1, label: "S", stickerId: "01" },
  ];

  // Filter grade options based on gradeRange
  const gradeOptions = gradeRange
    ? gradeMapping.filter(
        (grade) =>
          grade.value >= gradeRange.start && grade.value <= gradeRange.end
      )
    : gradeMapping;

  useEffect(() => {
    const currentUrl = window.location.href;
    const parsedUrl = queryString.parseUrl(currentUrl);
    const { serialNumber, listId, termId } = parsedUrl.query;
    const params = {
      listId: listId,
      termId: termId,
      serialNumber: serialNumber,
    };
    dispatch(init(params));
  }, [dispatch]);

  const submitSave = (param) => {
    const allSelected = item.every((item) => param[item.itemId]);
    console.log("allSelected:", allSelected);
    if (allSelected) {
      const evaluations = Object.keys(param).reduce((acc, itemId) => {
        const selectedLabel = param[itemId];
        const gradeOption = gradeOptions.find(
          (option) => option.label === selectedLabel
        );
        if (gradeOption) {
          acc[itemId] = selectedLabel;
        }
        return acc;
      }, {});
      dispatch(save({ ...evaluations }));
    } else {
      alert("選択されていない評価項目があります");
    }
  };

  return (
    <Box>
      <Header />
      <Container maxWidth={"md"}>
        <Box
          sx={{
            marginTop: 4,
            marginLeft: "vw",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            評価実施
          </Typography>
        </Box>
      </Container>

      <Container maxWidth={"md"}>
        <Box
          sx={{
            marginTop: 4,
            marginLeft: "vw",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography component="h4" variant="h9" align="left" marginLeft={4}>
            対象生徒：{grade + "-" + classNumber + "-" + number + " " + name}
          </Typography>
        </Box>
      </Container>

      <Container maxWidth={"md"}>
        <Box
          sx={{
            marginTop: 4,
            marginLeft: "vw",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography component="h4" variant="h9" align="left" marginLeft={4}>
            {title}について評価を行う。
          </Typography>
        </Box>
      </Container>

      {item.map((item, index) => (
        <Container maxWidth="md" sx={{ ml: "vw" }} key={item.itemId}>
          <Box
            sx={{
              m: 2,
              display: "flex",
              flexDirection: "column",
              bgcolor: "#fff9c4"
            }}
          >
            <Stack direction="column" spacing={1} sx={{ mt: 1 }}>
              <FormControl sx={{ mr: 3, ml: 1, pl: 2 }}>
                <Typography variant="h7" align="left" >
                  {`${index + 1}. ${item.itemName}`}
                </Typography>
              </FormControl>
              <FormControl sx={{ ml: 5, pl: 4 }}>
                <RadioGroup
                  row
                  aria-labelledby={`demo-row-radio-buttons-group-label-${index}`}
                  name={`row-radio-buttons-group-${index}`}
                  spacing={5}
                >
                  {gradeOptions.map((option) => (
                    <FormControlLabel
                      key={option.label}
                      value={option.label}
                      control={<Radio />}
                      label={option.label}
                      sx={{ mr: 5 }}
                      {...register(item.itemId)}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Stack>
          </Box>
        </Container>
      ))}

      <Container maxWidth="sm" sx={{ mt: 5 }}>
        <Button
          variant="contained"
          size="large"
          onClick={handleSubmit(submitSave)}
          sx={{ bgcolor: "#82b1ff" }}
        >
          登録
        </Button>
      </Container>

      <Box
        sx={{
          alignItems: "right",
          justifyContent: "right",
          m: 2,
          mr: 12,
          display: "flex",
        }}
      >
        <Button
          variant="contained"
          size="large"
          href="/EvaluationImplement"
          sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}
        >
          戻る
        </Button>
      </Box>
    </Box>
  );
}
